/**
 * @fileoverview gRPC-Web generated client stub for manager.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.6
// source: manager.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var base_pb = require('./base_pb.js')
const proto = {};
proto.manager = {};
proto.manager.v1 = require('./manager_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.manager.v1.ApiManagerClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.manager.v1.ApiManagerPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerSignInRequest,
 *   !proto.base.v1.SignInReply>}
 */
const methodDescriptor_ApiManager_ManagerSignIn = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerSignIn',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerSignInRequest,
  base_pb.SignInReply,
  /**
   * @param {!proto.manager.v1.ManagerSignInRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.SignInReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerSignInRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.SignInReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.SignInReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerSignIn =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerSignIn',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerSignIn,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerSignInRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.SignInReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerSignIn =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerSignIn',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerSignIn);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.GenVerifyPicRequest,
 *   !proto.manager.v1.GenVerifyPicReply>}
 */
const methodDescriptor_ApiManager_ManagerGenVerifyPic = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerGenVerifyPic',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.GenVerifyPicRequest,
  proto.manager.v1.GenVerifyPicReply,
  /**
   * @param {!proto.manager.v1.GenVerifyPicRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.manager.v1.GenVerifyPicReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.GenVerifyPicRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.manager.v1.GenVerifyPicReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manager.v1.GenVerifyPicReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerGenVerifyPic =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerGenVerifyPic',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerGenVerifyPic,
      callback);
};


/**
 * @param {!proto.manager.v1.GenVerifyPicRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manager.v1.GenVerifyPicReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerGenVerifyPic =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerGenVerifyPic',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerGenVerifyPic);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.base.v1.DefaultRequest,
 *   !proto.manager.v1.StdRsReply>}
 */
const methodDescriptor_ApiManager_ManagerGetUserInfo = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerGetUserInfo',
  grpc.web.MethodType.UNARY,
  base_pb.DefaultRequest,
  proto.manager.v1.StdRsReply,
  /**
   * @param {!proto.base.v1.DefaultRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.manager.v1.StdRsReply.deserializeBinary
);


/**
 * @param {!proto.base.v1.DefaultRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.manager.v1.StdRsReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manager.v1.StdRsReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerGetUserInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerGetUserInfo',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerGetUserInfo,
      callback);
};


/**
 * @param {!proto.base.v1.DefaultRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manager.v1.StdRsReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerGetUserInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerGetUserInfo',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerGetUserInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.base.v1.DefaultRequest,
 *   !proto.manager.v1.StdRsReply>}
 */
const methodDescriptor_ApiManager_ManagerColumnQuery = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerColumnQuery',
  grpc.web.MethodType.UNARY,
  base_pb.DefaultRequest,
  proto.manager.v1.StdRsReply,
  /**
   * @param {!proto.base.v1.DefaultRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.manager.v1.StdRsReply.deserializeBinary
);


/**
 * @param {!proto.base.v1.DefaultRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.manager.v1.StdRsReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manager.v1.StdRsReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerColumnQuery =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerColumnQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerColumnQuery,
      callback);
};


/**
 * @param {!proto.base.v1.DefaultRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manager.v1.StdRsReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerColumnQuery =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerColumnQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerColumnQuery);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerApkListQueryRequest,
 *   !proto.manager.v1.StdRsReply>}
 */
const methodDescriptor_ApiManager_ManagerApkListQuery = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerApkListQuery',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerApkListQueryRequest,
  proto.manager.v1.StdRsReply,
  /**
   * @param {!proto.manager.v1.ManagerApkListQueryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.manager.v1.StdRsReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerApkListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.manager.v1.StdRsReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manager.v1.StdRsReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerApkListQuery =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerApkListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerApkListQuery,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerApkListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manager.v1.StdRsReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerApkListQuery =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerApkListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerApkListQuery);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerApkAddRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerApkAdd = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerApkAdd',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerApkAddRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerApkAddRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerApkAddRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerApkAdd =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerApkAdd',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerApkAdd,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerApkAddRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerApkAdd =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerApkAdd',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerApkAdd);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerApkEditRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerApkEdit = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerApkEdit',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerApkEditRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerApkEditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerApkEditRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerApkEdit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerApkEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerApkEdit,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerApkEditRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerApkEdit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerApkEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerApkEdit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.base.v1.StatusEditRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerApkStatusEdit = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerApkStatusEdit',
  grpc.web.MethodType.UNARY,
  base_pb.StatusEditRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.base.v1.StatusEditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.base.v1.StatusEditRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerApkStatusEdit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerApkStatusEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerApkStatusEdit,
      callback);
};


/**
 * @param {!proto.base.v1.StatusEditRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerApkStatusEdit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerApkStatusEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerApkStatusEdit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.FileChunk,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerApkUpLoad = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerApkUpLoad',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.FileChunk,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.FileChunk} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.FileChunk} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerApkUpLoad =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerApkUpLoad',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerApkUpLoad,
      callback);
};


/**
 * @param {!proto.manager.v1.FileChunk} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerApkUpLoad =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerApkUpLoad',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerApkUpLoad);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.base.v1.DefaultRequest,
 *   !proto.manager.v1.StdRsReply>}
 */
const methodDescriptor_ApiManager_ManagerRegionList = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerRegionList',
  grpc.web.MethodType.UNARY,
  base_pb.DefaultRequest,
  proto.manager.v1.StdRsReply,
  /**
   * @param {!proto.base.v1.DefaultRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.manager.v1.StdRsReply.deserializeBinary
);


/**
 * @param {!proto.base.v1.DefaultRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.manager.v1.StdRsReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manager.v1.StdRsReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerRegionList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerRegionList',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerRegionList,
      callback);
};


/**
 * @param {!proto.base.v1.DefaultRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manager.v1.StdRsReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerRegionList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerRegionList',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerRegionList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerLocationListQueryRequest,
 *   !proto.manager.v1.StdRsReply>}
 */
const methodDescriptor_ApiManager_ManagerLocationListQuery = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerLocationListQuery',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerLocationListQueryRequest,
  proto.manager.v1.StdRsReply,
  /**
   * @param {!proto.manager.v1.ManagerLocationListQueryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.manager.v1.StdRsReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerLocationListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.manager.v1.StdRsReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manager.v1.StdRsReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerLocationListQuery =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerLocationListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerLocationListQuery,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerLocationListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manager.v1.StdRsReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerLocationListQuery =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerLocationListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerLocationListQuery);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerLocationAddRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerLocationAdd = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerLocationAdd',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerLocationAddRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerLocationAddRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerLocationAddRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerLocationAdd =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerLocationAdd',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerLocationAdd,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerLocationAddRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerLocationAdd =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerLocationAdd',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerLocationAdd);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerLocationEditRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerLocationEdit = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerLocationEdit',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerLocationEditRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerLocationEditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerLocationEditRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerLocationEdit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerLocationEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerLocationEdit,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerLocationEditRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerLocationEdit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerLocationEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerLocationEdit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.base.v1.StatusEditRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerLocationStatusEdit = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerLocationStatusEdit',
  grpc.web.MethodType.UNARY,
  base_pb.StatusEditRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.base.v1.StatusEditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.base.v1.StatusEditRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerLocationStatusEdit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerLocationStatusEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerLocationStatusEdit,
      callback);
};


/**
 * @param {!proto.base.v1.StatusEditRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerLocationStatusEdit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerLocationStatusEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerLocationStatusEdit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerMapListQueryRequest,
 *   !proto.manager.v1.StdRsReply>}
 */
const methodDescriptor_ApiManager_ManagerMapListQuery = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerMapListQuery',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerMapListQueryRequest,
  proto.manager.v1.StdRsReply,
  /**
   * @param {!proto.manager.v1.ManagerMapListQueryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.manager.v1.StdRsReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerMapListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.manager.v1.StdRsReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manager.v1.StdRsReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerMapListQuery =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerMapListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerMapListQuery,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerMapListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manager.v1.StdRsReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerMapListQuery =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerMapListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerMapListQuery);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerMapAddRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerMapAdd = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerMapAdd',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerMapAddRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerMapAddRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerMapAddRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerMapAdd =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerMapAdd',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerMapAdd,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerMapAddRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerMapAdd =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerMapAdd',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerMapAdd);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerMapEditRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerMapEdit = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerMapEdit',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerMapEditRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerMapEditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerMapEditRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerMapEdit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerMapEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerMapEdit,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerMapEditRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerMapEdit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerMapEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerMapEdit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerMapHistoryEditRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerHistoryMapEdit = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerHistoryMapEdit',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerMapHistoryEditRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerMapHistoryEditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerMapHistoryEditRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerHistoryMapEdit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerHistoryMapEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerHistoryMapEdit,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerMapHistoryEditRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerHistoryMapEdit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerHistoryMapEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerHistoryMapEdit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.base.v1.StatusEditRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerMapStatusEdit = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerMapStatusEdit',
  grpc.web.MethodType.UNARY,
  base_pb.StatusEditRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.base.v1.StatusEditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.base.v1.StatusEditRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerMapStatusEdit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerMapStatusEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerMapStatusEdit,
      callback);
};


/**
 * @param {!proto.base.v1.StatusEditRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerMapStatusEdit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerMapStatusEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerMapStatusEdit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerRouteListQueryRequest,
 *   !proto.manager.v1.StdRsReply>}
 */
const methodDescriptor_ApiManager_ManagerRouteListQuery = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerRouteListQuery',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerRouteListQueryRequest,
  proto.manager.v1.StdRsReply,
  /**
   * @param {!proto.manager.v1.ManagerRouteListQueryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.manager.v1.StdRsReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerRouteListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.manager.v1.StdRsReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manager.v1.StdRsReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerRouteListQuery =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerRouteListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerRouteListQuery,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerRouteListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manager.v1.StdRsReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerRouteListQuery =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerRouteListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerRouteListQuery);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerRouteAddRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerRouteAdd = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerRouteAdd',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerRouteAddRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerRouteAddRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerRouteAddRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerRouteAdd =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerRouteAdd',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerRouteAdd,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerRouteAddRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerRouteAdd =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerRouteAdd',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerRouteAdd);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerRouteEditRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerRouteEdit = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerRouteEdit',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerRouteEditRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerRouteEditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerRouteEditRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerRouteEdit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerRouteEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerRouteEdit,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerRouteEditRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerRouteEdit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerRouteEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerRouteEdit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.base.v1.StatusEditRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerRouteStatusEdit = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerRouteStatusEdit',
  grpc.web.MethodType.UNARY,
  base_pb.StatusEditRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.base.v1.StatusEditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.base.v1.StatusEditRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerRouteStatusEdit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerRouteStatusEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerRouteStatusEdit,
      callback);
};


/**
 * @param {!proto.base.v1.StatusEditRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerRouteStatusEdit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerRouteStatusEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerRouteStatusEdit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerRouteListQueryInPackageRequest,
 *   !proto.manager.v1.StdRsReply>}
 */
const methodDescriptor_ApiManager_ManagerRouteListQueryInPackage = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerRouteListQueryInPackage',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerRouteListQueryInPackageRequest,
  proto.manager.v1.StdRsReply,
  /**
   * @param {!proto.manager.v1.ManagerRouteListQueryInPackageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.manager.v1.StdRsReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerRouteListQueryInPackageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.manager.v1.StdRsReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manager.v1.StdRsReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerRouteListQueryInPackage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerRouteListQueryInPackage',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerRouteListQueryInPackage,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerRouteListQueryInPackageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manager.v1.StdRsReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerRouteListQueryInPackage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerRouteListQueryInPackage',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerRouteListQueryInPackage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerRouteListQueryOutPackageRequest,
 *   !proto.manager.v1.StdRsReply>}
 */
const methodDescriptor_ApiManager_ManagerRouteListQueryOutPackage = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerRouteListQueryOutPackage',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerRouteListQueryOutPackageRequest,
  proto.manager.v1.StdRsReply,
  /**
   * @param {!proto.manager.v1.ManagerRouteListQueryOutPackageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.manager.v1.StdRsReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerRouteListQueryOutPackageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.manager.v1.StdRsReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manager.v1.StdRsReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerRouteListQueryOutPackage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerRouteListQueryOutPackage',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerRouteListQueryOutPackage,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerRouteListQueryOutPackageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manager.v1.StdRsReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerRouteListQueryOutPackage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerRouteListQueryOutPackage',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerRouteListQueryOutPackage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerCoursePackageRelationRouteRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerCoursePackageRelationRoute = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerCoursePackageRelationRoute',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerCoursePackageRelationRouteRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerCoursePackageRelationRouteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerCoursePackageRelationRouteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerCoursePackageRelationRoute =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerCoursePackageRelationRoute',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerCoursePackageRelationRoute,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerCoursePackageRelationRouteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerCoursePackageRelationRoute =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerCoursePackageRelationRoute',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerCoursePackageRelationRoute);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerCoursePackageListQueryRequest,
 *   !proto.manager.v1.StdRsReply>}
 */
const methodDescriptor_ApiManager_ManagerCoursePackageListQuery = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerCoursePackageListQuery',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerCoursePackageListQueryRequest,
  proto.manager.v1.StdRsReply,
  /**
   * @param {!proto.manager.v1.ManagerCoursePackageListQueryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.manager.v1.StdRsReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerCoursePackageListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.manager.v1.StdRsReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manager.v1.StdRsReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerCoursePackageListQuery =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerCoursePackageListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerCoursePackageListQuery,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerCoursePackageListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manager.v1.StdRsReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerCoursePackageListQuery =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerCoursePackageListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerCoursePackageListQuery);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerCoursePackageAddRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerCoursePackageAdd = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerCoursePackageAdd',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerCoursePackageAddRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerCoursePackageAddRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerCoursePackageAddRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerCoursePackageAdd =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerCoursePackageAdd',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerCoursePackageAdd,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerCoursePackageAddRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerCoursePackageAdd =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerCoursePackageAdd',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerCoursePackageAdd);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerCoursePackageEditRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerCoursePackageEdit = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerCoursePackageEdit',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerCoursePackageEditRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerCoursePackageEditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerCoursePackageEditRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerCoursePackageEdit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerCoursePackageEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerCoursePackageEdit,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerCoursePackageEditRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerCoursePackageEdit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerCoursePackageEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerCoursePackageEdit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.base.v1.StatusEditRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerCoursePackageStatusEdit = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerCoursePackageStatusEdit',
  grpc.web.MethodType.UNARY,
  base_pb.StatusEditRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.base.v1.StatusEditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.base.v1.StatusEditRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerCoursePackageStatusEdit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerCoursePackageStatusEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerCoursePackageStatusEdit,
      callback);
};


/**
 * @param {!proto.base.v1.StatusEditRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerCoursePackageStatusEdit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerCoursePackageStatusEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerCoursePackageStatusEdit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerCoursePackageRelationRouteRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerCoursePackageRelationRouteAdd = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerCoursePackageRelationRouteAdd',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerCoursePackageRelationRouteRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerCoursePackageRelationRouteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerCoursePackageRelationRouteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerCoursePackageRelationRouteAdd =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerCoursePackageRelationRouteAdd',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerCoursePackageRelationRouteAdd,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerCoursePackageRelationRouteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerCoursePackageRelationRouteAdd =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerCoursePackageRelationRouteAdd',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerCoursePackageRelationRouteAdd);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerCoursePackageRelationRouteRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerCoursePackageRelationRouteDel = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerCoursePackageRelationRouteDel',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerCoursePackageRelationRouteRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerCoursePackageRelationRouteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerCoursePackageRelationRouteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerCoursePackageRelationRouteDel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerCoursePackageRelationRouteDel',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerCoursePackageRelationRouteDel,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerCoursePackageRelationRouteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerCoursePackageRelationRouteDel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerCoursePackageRelationRouteDel',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerCoursePackageRelationRouteDel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerControlPointListQueryRequest,
 *   !proto.manager.v1.StdRsReply>}
 */
const methodDescriptor_ApiManager_ManagerControlPointListQuery = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerControlPointListQuery',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerControlPointListQueryRequest,
  proto.manager.v1.StdRsReply,
  /**
   * @param {!proto.manager.v1.ManagerControlPointListQueryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.manager.v1.StdRsReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerControlPointListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.manager.v1.StdRsReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manager.v1.StdRsReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerControlPointListQuery =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerControlPointListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerControlPointListQuery,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerControlPointListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manager.v1.StdRsReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerControlPointListQuery =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerControlPointListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerControlPointListQuery);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerControlPointImportRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerControlPointImportAdd = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerControlPointImportAdd',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerControlPointImportRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerControlPointImportRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerControlPointImportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerControlPointImportAdd =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerControlPointImportAdd',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerControlPointImportAdd,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerControlPointImportRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerControlPointImportAdd =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerControlPointImportAdd',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerControlPointImportAdd);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManageControlPointAddRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerControlPointAdd = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerControlPointAdd',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManageControlPointAddRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManageControlPointAddRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManageControlPointAddRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerControlPointAdd =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerControlPointAdd',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerControlPointAdd,
      callback);
};


/**
 * @param {!proto.manager.v1.ManageControlPointAddRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerControlPointAdd =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerControlPointAdd',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerControlPointAdd);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerControlPointEditRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerControlPointEdit = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerControlPointEdit',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerControlPointEditRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerControlPointEditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerControlPointEditRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerControlPointEdit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerControlPointEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerControlPointEdit,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerControlPointEditRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerControlPointEdit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerControlPointEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerControlPointEdit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.base.v1.StatusEditRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerControlPointStatusEdit = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerControlPointStatusEdit',
  grpc.web.MethodType.UNARY,
  base_pb.StatusEditRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.base.v1.StatusEditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.base.v1.StatusEditRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerControlPointStatusEdit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerControlPointStatusEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerControlPointStatusEdit,
      callback);
};


/**
 * @param {!proto.base.v1.StatusEditRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerControlPointStatusEdit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerControlPointStatusEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerControlPointStatusEdit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerPlanListQueryRequest,
 *   !proto.manager.v1.StdRsReply>}
 */
const methodDescriptor_ApiManager_ManagerPlanListQuery = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerPlanListQuery',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerPlanListQueryRequest,
  proto.manager.v1.StdRsReply,
  /**
   * @param {!proto.manager.v1.ManagerPlanListQueryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.manager.v1.StdRsReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerPlanListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.manager.v1.StdRsReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manager.v1.StdRsReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerPlanListQuery =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerPlanListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerPlanListQuery,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerPlanListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manager.v1.StdRsReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerPlanListQuery =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerPlanListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerPlanListQuery);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerPlanAddRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerPlanAdd = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerPlanAdd',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerPlanAddRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerPlanAddRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerPlanAddRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerPlanAdd =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerPlanAdd',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerPlanAdd,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerPlanAddRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerPlanAdd =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerPlanAdd',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerPlanAdd);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerPlanEditRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerPlanEdit = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerPlanEdit',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerPlanEditRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerPlanEditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerPlanEditRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerPlanEdit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerPlanEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerPlanEdit,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerPlanEditRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerPlanEdit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerPlanEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerPlanEdit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.base.v1.StatusEditRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerPlanStatusEdit = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerPlanStatusEdit',
  grpc.web.MethodType.UNARY,
  base_pb.StatusEditRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.base.v1.StatusEditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.base.v1.StatusEditRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerPlanStatusEdit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerPlanStatusEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerPlanStatusEdit,
      callback);
};


/**
 * @param {!proto.base.v1.StatusEditRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerPlanStatusEdit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerPlanStatusEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerPlanStatusEdit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerPlanRelationPackageRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerPlanRelationPackage = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerPlanRelationPackage',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerPlanRelationPackageRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerPlanRelationPackageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerPlanRelationPackageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerPlanRelationPackage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerPlanRelationPackage',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerPlanRelationPackage,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerPlanRelationPackageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerPlanRelationPackage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerPlanRelationPackage',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerPlanRelationPackage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerPlanCoursePackageListQueryRequest,
 *   !proto.manager.v1.StdRsReply>}
 */
const methodDescriptor_ApiManager_ManagerPlanCoursePackageListQuery = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerPlanCoursePackageListQuery',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerPlanCoursePackageListQueryRequest,
  proto.manager.v1.StdRsReply,
  /**
   * @param {!proto.manager.v1.ManagerPlanCoursePackageListQueryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.manager.v1.StdRsReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerPlanCoursePackageListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.manager.v1.StdRsReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manager.v1.StdRsReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerPlanCoursePackageListQuery =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerPlanCoursePackageListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerPlanCoursePackageListQuery,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerPlanCoursePackageListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manager.v1.StdRsReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerPlanCoursePackageListQuery =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerPlanCoursePackageListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerPlanCoursePackageListQuery);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerActiveListQueryRequest,
 *   !proto.manager.v1.StdRsReply>}
 */
const methodDescriptor_ApiManager_ManagerActiveListQuery = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerActiveListQuery',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerActiveListQueryRequest,
  proto.manager.v1.StdRsReply,
  /**
   * @param {!proto.manager.v1.ManagerActiveListQueryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.manager.v1.StdRsReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerActiveListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.manager.v1.StdRsReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manager.v1.StdRsReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerActiveListQuery =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerActiveListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerActiveListQuery,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerActiveListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manager.v1.StdRsReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerActiveListQuery =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerActiveListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerActiveListQuery);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerActiveAddRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerActiveAdd = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerActiveAdd',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerActiveAddRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerActiveAddRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerActiveAddRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerActiveAdd =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerActiveAdd',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerActiveAdd,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerActiveAddRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerActiveAdd =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerActiveAdd',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerActiveAdd);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerActiveEditRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerActiveEdit = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerActiveEdit',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerActiveEditRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerActiveEditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerActiveEditRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerActiveEdit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerActiveEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerActiveEdit,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerActiveEditRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerActiveEdit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerActiveEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerActiveEdit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.base.v1.StatusEditRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerActiveStatusEdit = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerActiveStatusEdit',
  grpc.web.MethodType.UNARY,
  base_pb.StatusEditRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.base.v1.StatusEditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.base.v1.StatusEditRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerActiveStatusEdit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerActiveStatusEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerActiveStatusEdit,
      callback);
};


/**
 * @param {!proto.base.v1.StatusEditRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerActiveStatusEdit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerActiveStatusEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerActiveStatusEdit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerActiveRuleListQueryRequest,
 *   !proto.manager.v1.StdRsReply>}
 */
const methodDescriptor_ApiManager_ManagerActiveRuleListQuery = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerActiveRuleListQuery',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerActiveRuleListQueryRequest,
  proto.manager.v1.StdRsReply,
  /**
   * @param {!proto.manager.v1.ManagerActiveRuleListQueryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.manager.v1.StdRsReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerActiveRuleListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.manager.v1.StdRsReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manager.v1.StdRsReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerActiveRuleListQuery =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerActiveRuleListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerActiveRuleListQuery,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerActiveRuleListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manager.v1.StdRsReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerActiveRuleListQuery =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerActiveRuleListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerActiveRuleListQuery);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerActiveRuleEditRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerActiveRuleEdit = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerActiveRuleEdit',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerActiveRuleEditRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerActiveRuleEditRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerActiveRuleEditRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerActiveRuleEdit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerActiveRuleEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerActiveRuleEdit,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerActiveRuleEditRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerActiveRuleEdit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerActiveRuleEdit',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerActiveRuleEdit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerActiveDetailRequest,
 *   !proto.manager.v1.ManagerActiveInfo>}
 */
const methodDescriptor_ApiManager_ManagerActiveDetailQuery = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerActiveDetailQuery',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerActiveDetailRequest,
  proto.manager.v1.ManagerActiveInfo,
  /**
   * @param {!proto.manager.v1.ManagerActiveDetailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.manager.v1.ManagerActiveInfo.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerActiveDetailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.manager.v1.ManagerActiveInfo)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manager.v1.ManagerActiveInfo>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerActiveDetailQuery =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerActiveDetailQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerActiveDetailQuery,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerActiveDetailRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manager.v1.ManagerActiveInfo>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerActiveDetailQuery =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerActiveDetailQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerActiveDetailQuery);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerUploadInfoListQueryRequest,
 *   !proto.manager.v1.StdRsReply>}
 */
const methodDescriptor_ApiManager_ManagerUploadInfoListQuery = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerUploadInfoListQuery',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerUploadInfoListQueryRequest,
  proto.manager.v1.StdRsReply,
  /**
   * @param {!proto.manager.v1.ManagerUploadInfoListQueryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.manager.v1.StdRsReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerUploadInfoListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.manager.v1.StdRsReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manager.v1.StdRsReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerUploadInfoListQuery =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerUploadInfoListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerUploadInfoListQuery,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerUploadInfoListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manager.v1.StdRsReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerUploadInfoListQuery =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerUploadInfoListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerUploadInfoListQuery);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerUploadInfoAuditingRequest,
 *   !proto.base.v1.DefaultReply>}
 */
const methodDescriptor_ApiManager_ManagerUploadInfoAuditing = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerUploadInfoAuditing',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerUploadInfoAuditingRequest,
  base_pb.DefaultReply,
  /**
   * @param {!proto.manager.v1.ManagerUploadInfoAuditingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  base_pb.DefaultReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerUploadInfoAuditingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.base.v1.DefaultReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.base.v1.DefaultReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerUploadInfoAuditing =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerUploadInfoAuditing',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerUploadInfoAuditing,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerUploadInfoAuditingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.base.v1.DefaultReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerUploadInfoAuditing =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerUploadInfoAuditing',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerUploadInfoAuditing);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.manager.v1.ManagerOiListQueryRequest,
 *   !proto.manager.v1.StdRsReply>}
 */
const methodDescriptor_ApiManager_ManagerOiListQuery = new grpc.web.MethodDescriptor(
  '/manager.v1.ApiManager/ManagerOiListQuery',
  grpc.web.MethodType.UNARY,
  proto.manager.v1.ManagerOiListQueryRequest,
  proto.manager.v1.StdRsReply,
  /**
   * @param {!proto.manager.v1.ManagerOiListQueryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.manager.v1.StdRsReply.deserializeBinary
);


/**
 * @param {!proto.manager.v1.ManagerOiListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.manager.v1.StdRsReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.manager.v1.StdRsReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.manager.v1.ApiManagerClient.prototype.managerOiListQuery =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerOiListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerOiListQuery,
      callback);
};


/**
 * @param {!proto.manager.v1.ManagerOiListQueryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.manager.v1.StdRsReply>}
 *     Promise that resolves to the response
 */
proto.manager.v1.ApiManagerPromiseClient.prototype.managerOiListQuery =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/manager.v1.ApiManager/ManagerOiListQuery',
      request,
      metadata || {},
      methodDescriptor_ApiManager_ManagerOiListQuery);
};


module.exports = proto.manager.v1;

